var s = process.env.NODE_ENV !== "production", d = function(i, n) {
  for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), e = 2; e < r; e++)
    o[e - 2] = arguments[e];
  if (s && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !i))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return o[a++];
      }));
    }
};
export {
  d as warn
};
